export class ERedShirtType {
    public static readonly Y = 1;//Yes
    public static readonly N = 2;//No
    public static readonly C = 3;//Counts Against Competition
    public static readonly V = 4;//Coronavirus Season
}